import React from 'react';
import Layout from '../components/Layout';

const MainPage = () => {
  return <Layout></Layout>;
};

export default MainPage;
